<template>
  <div class="footer">
    <router-link to="/" class="footer_item" :class="show_icon_type === 'index' ? 'footer_item_active' : ''">
      <span class="footer_icon">
        <img v-if="show_icon_type === 'index'" src="../assets/images/tab/shouye2.png" alt="首页">
        <img v-else src="../assets/images/tab/shouye.png" alt="首页">
      </span>
      <p class="footer_info">
        {{$t('home.index')}}
      </p>
    </router-link>
    <router-link to="/allProducts" class="footer_item" :class="show_icon_type === 'item' ? 'footer_item_active' : ''">
      <span class="footer_icon">
        <img v-if="show_icon_type === 'item'" src="../assets/images/tab/xiangmu2.png" alt="项目">
        <img v-else src="../assets/images/tab/xiangmu.png" alt="项目">
      </span>
      <p class="footer_info">
        {{$t('home.item')}}
      </p>
    </router-link>
    <div @click="jumpToCustomerService" class="footer_item" :class="show_icon_type === 'cart' ? 'footer_item_active' : ''">
      <span class="footer_icon">
        <img v-if="show_icon_type === 'cart'" src="../assets/images/tab/kefu2.png" alt="客服">
        <img v-else src="../assets/images/tab/kefu1.png" alt="客服">
      </span>
      <p class="footer_info">
        {{$t('home.activity')}}
      </p>
    </div>
    <router-link to="/loan" class="footer_item" :class="show_icon_type === 'loan' ? 'footer_item_active' : ''">
      <span class="footer_icon">
        <img v-if="show_icon_type === 'loan'" src="../assets/images/tab/daikuan2.png" :alt="$t('index.loan')">
        <img v-else src="../assets/images/tab/daikuan.png" :alt="$t('index.loan')">
      </span>
      <p class="footer_info">
        {{$t('index.loan')}}
      </p>
    </router-link>
    <router-link to="/userCenter" class="footer_item" :class="show_icon_type === 'user' ? 'footer_item_active' : ''">
      <span class="footer_icon">
        <img v-if="show_icon_type === 'user'" src="../assets/images/tab/wode2.png" alt="我的">
        <img v-else src="../assets/images/tab/wode.png" alt="我的">
      </span>
      <p class="footer_info">
        {{$t('home.my')}}
      </p>
    </router-link>
  </div>
</template>

<script>
import Fetch from '../utils/fetch'

export default {
  name: "FooterTab",
  props: {
    // 当前激活的tab类型：index, item, cart, user
    activeType: {
      type: String,
      default: 'index'
    }
  },
  data() {
    return {
      kefuLoading: false // 客服跳转loading状态
    };
  },
  computed: {
    show_icon_type() {
      return this.activeType;
    }
  },
  created() {
    // 通知父组件显示底部导航
    if (this.$parent && this.$parent.footer) {
      this.$parent.footer("user", false);
    }
  },
  methods: {
    // 显示贷款提示
    showLoanMessage() {
      this.$toast('系统升级中，敬请期待.....');
    },
	
	isNotEmpty(value) {
	  return value !== null && 
	         value !== undefined && 
	         value !== '';
	},
    
    // 直接跳转到客服，与用户中心保持一致
    jumpToCustomerService() {
      // 防止重复点击
      if (this.kefuLoading) return;
      
      this.kefuLoading = true;
      console.log('底部导航直接跳转客服，获取配置...');
      
      let agent = localStorage.getItem('agent');
      Fetch('/index/webconfig', {agent, type: 'web'}).then(res => {
        if (res.data.kefu_link) {
          console.log('底部导航跳转到客服:', res.data.kefu_link);
		  
		  const userInfo = this.$store.getters.getUserInfo;
		  let $metadata = '';
		  if(this.isNotEmpty(userInfo)){//当登入的时候才传参数
			  $metadata = '?metadata={"id":"'+userInfo.uid+'","mobile":"'+userInfo.mobile+'","vip_name":"'+userInfo.vip_name+'"}';
		  }
		  window.location.href = res.data.kefu_link + $metadata;
        } else {
          this.$toast('客服配置错误');
        }
      }).catch(err => {
        console.error('获取客服配置失败:', err);
        this.$toast('客服暂时不可用，请稍后重试');
      }).finally(() => {
        this.kefuLoading = false;
      });
    }
  }
}
</script>

<style scoped>
.footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 60px;
  background: #fff;
  border-top: 1px solid #e5e5e5;
  display: flex;
  z-index: 1000;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);
}

.footer .footer_item {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  color: #999;
  transition: all 0.3s ease;
  cursor: pointer;
  position: relative;
  padding: 8px 0;
}

/* 点击动画效果 */
.footer .footer_item:active {
  transform: scale(0.9);
  transition: transform 0.1s ease;
}

/* 激活状态 */
.footer .footer_item_active {
  color: #1677FF;
}

/* 激活状态的弹跳动画 */
.footer .footer_item_active .footer_icon {
  animation: bounce 0.5s ease;
}

@keyframes bounce {
  0%, 100% {
    transform: translateY(0);
  }
  25% {
    transform: translateY(-6px);
  }
  50% {
    transform: translateY(0);
  }
  75% {
    transform: translateY(-3px);
  }
}

.footer .footer_item .footer_icon {
  width: 28px;
  height: 28px;
  margin-bottom: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.3s ease;
}

.footer .footer_item .footer_icon img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  transition: all 0.3s ease;
}

/* 悬停效果 */
.footer .footer_item:hover .footer_icon img {
  transform: scale(1.1);
}

.footer .footer_item .footer_info {
  font-size: 11px;
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  max-width: 60px;
  display: block;
  text-align: center;
  line-height: 1.2;
  font-weight: 400;
  transition: all 0.3s ease;
}

/* 激活状态的文字 */
.footer .footer_item_active .footer_info {
  font-weight: 600;
  color: #1677FF;
}

/* 涟漪效果 */
.footer .footer_item::after {
  content: '';
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background: rgba(22, 119, 255, 0.2);
  transform: scale(0);
  opacity: 0;
  pointer-events: none;
  transition: transform 0.4s ease, opacity 0.4s ease;
}

.footer .footer_item:active::after {
  transform: scale(1.5);
  opacity: 1;
  transition: transform 0s, opacity 0.1s;
}
</style> 